<template>
    <nav aria-label="breadcrumb" class="tw:flex tw:items-center tw:bg-gray-50 tw:rounded-lg tw:px-4 tw:py-2.5 tw:text-sm">
        <template v-for="(item, index) in items">
            <button
                v-if="index < resolvedActiveIndex"
                :key="'btn-' + index"
                type="button"
                class="tw:text-blue-600 hover:tw:text-blue-800 hover:tw:underline tw:transition-colors tw:font-medium tw:cursor-pointer tw:bg-transparent tw:border-none tw:p-0"
                @click="emit('navigate', item, index)"
            >
                <span v-if="index === 0">🏠 </span>{{ item.name }}
            </button>
            <span
                v-else
                :key="'text-' + index"
                class="tw:text-gray-800 tw:font-semibold"
                aria-current="page"
            >
                {{ item.name }}
            </span>
            <span
                v-if="index < items.length - 1"
                :key="'sep-' + index"
                class="tw:text-gray-400 tw:mx-2 tw:select-none"
            >›</span>
        </template>
    </nav>
</template>

<script setup>
    import { computed } from 'vue'

    const props = defineProps({
        items: {
            type: Array,
            required: true
        },
        activeIndex: {
            type: Number,
            default: null
        }
    })

    const resolvedActiveIndex = computed(() => {
        if (props.activeIndex !== null) return props.activeIndex
        return props.items.length - 1
    })

    const emit = defineEmits(['navigate'])
</script>
